import { InputNumberProps } from 'antd';
import { ValueType } from '@rc-component/mini-decimal';
import {
	formatCurrency,
	formatCurrencyWithDot,
	formatNPWPValue,
} from './formater';

export const inputNPWP = {
	controls: false,
	formatter: (value?: ValueType) => formatNPWPValue(value as string),
	parser(displayValue?: string) {
		return displayValue
			?.replaceAll('.', '')
			.replaceAll('-', '') as unknown as string;
	},
	maxLength: 21,
	minLength: 20,
} as InputNumberProps;

export const inputCurrency = {
	controls: false,
	placeholder: '0',
	formatter: (value?: ValueType) => formatCurrency(value as number, false),
	parser: (value?: string) => {
		try {
			if (typeof value === 'string' && !value.length) {
				value = '0.0';
			}

			const group = new Intl.NumberFormat('id-ID')
				.format(1111)
				.replace(/1/g, '');
			const decimal = new Intl.NumberFormat('id-ID')
				.format(1.1)
				.replace(/1/g, '');
			let reversedVal: string | number | undefined = value?.replace(
				new RegExp('\\' + group, 'g'),
				'',
			);
			reversedVal = reversedVal?.replace(new RegExp('\\' + decimal, 'g'), '.');
			reversedVal = reversedVal?.replace(/[^0-9.]/g, '');

			return Number.isNaN(reversedVal) ? 0 : reversedVal;
		} catch (error) {
			console.error(error);
		}
	},
} as InputNumberProps;

export const inputCurrencyWithDot = {
	controls: false,
	placeholder: '0',
	formatter: (value?: ValueType) =>
		formatCurrencyWithDot(value as number, false),
	parser: (value?: string) => {
		try {
			if (typeof value === 'string' && !value.length) {
				value = '0.0';
			}

			const group = new Intl.NumberFormat('en-US')
				.format(1111111)
				.replace(/1/g, '');
			const decimal = new Intl.NumberFormat('en-US')
				.format(1.11111)
				.replace(/1/g, '');
			let reversedVal: string | number | undefined = value?.replace(
				new RegExp('\\' + group, 'g'),
				'',
			);
			reversedVal = reversedVal?.replace(new RegExp('\\' + decimal, 'g'), '.');
			reversedVal = reversedVal?.replace(/[^0-9.]/g, '');

			// Limit to maximum 5 decimal places for inputCurrencyWithDot (pure truncation, no rounding)
			if (reversedVal && typeof reversedVal === 'string') {
				const parts = reversedVal.split('.');
				if (parts.length === 2 && parts[1].length > 5) {
					// Pure truncation - cut off digits after the 5th decimal place without rounding
					const truncatedDecimals = parts[1].slice(0, 5);
					reversedVal = parts[0] + '.' + truncatedDecimals;
				}
			}

			return Number.isNaN(reversedVal) ? 0 : reversedVal;
		} catch (error) {
			console.error(error);
		}
	},
} as InputNumberProps;

export const inputThousand = {
	controls: false,
	prefix: '',
	placeholder: '0',
	formatter: (value?: ValueType) => formatCurrency(value as number, false),
	parser: (value?: string) => {
		try {
			if (typeof value === 'string' && !value.length) {
				value = '0.0';
			}

			const group = new Intl.NumberFormat('id-ID')
				.format(1111)
				.replace(/1/g, '');
			const decimal = new Intl.NumberFormat('id-ID')
				.format(1.1)
				.replace(/1/g, '');
			let reversedVal: string | number | undefined = value?.replace(
				new RegExp('\\' + group, 'g'),
				'',
			);
			reversedVal = reversedVal?.replace(new RegExp('\\' + decimal, 'g'), '.');
			reversedVal = reversedVal?.replace(/[^0-9.]/g, '');

			return Number.isNaN(reversedVal) ? 0 : reversedVal;
		} catch (error) {
			console.error(error);
		}
	},
} as InputNumberProps;

export const inputRtRw = {
	maxLength: 3,
	minLength: 3,
};
